import { render, staticRenderFns } from "./DataTableHeaderFilters.vue?vue&type=template&id=959797a8&"
var script = {}
import style0 from "./DataTableHeaderFilters.vue?vue&type=style&index=0&id=959797a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports